import axios from 'axios';

export const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URl,
    headers: { Authorization: `Bearer ${localStorage.getItem('@expo:token')}` },
});